import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { GeneralMeetingsResource } from '../../../services/resources/general-meetings.resource';

@Component({
    selector: 'sl-virtual-speakers-desk',
    templateUrl: './virtual-speakers-desk.component.html',
    styleUrls: ['./virtual-speakers-desk.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VirtualSpeakersDeskComponent implements OnInit {
    isSent = false;
    formGroup: FormGroup;

    private readonly formBuilder = inject(UntypedFormBuilder);
    private readonly generalMeetingsResource = inject(GeneralMeetingsResource);

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
            text: new FormControl(undefined, undefined),
            name: new FormControl(undefined, undefined),
            phone: new FormControl(undefined, undefined),
            email: new FormControl(undefined, Validators.email)
        });
    }

    submit(): void {
        if (this.formGroup.valid) {
            this.generalMeetingsResource
                .submitQuestion(
                    this.formGroup.value.text,
                    this.formGroup.value.name,
                    this.formGroup.value.phone,
                    this.formGroup.value.email
                )
                .subscribe(r => {
                    this.isSent = r.isSuccessful;
                });
        }
    }
}
